module.exports = __webpack_public_path__ + "static/media/trash.1bdec2b8.svg";